import * as $ from "jquery";
import { encrypt } from "./md5";
/*+***********************************************************************************
 * The contents of this file are subject to the Vtiger CRM Public License Version 1.0
 * ("License"); You may not use this file except in compliance with the License
 * The Original Code is:  Vtiger CRM Open Source
 * The Initial Developer of the Original Code is Vtiger.
 * Portions created by Vtiger are Copyright (C) www.vtiger.com
 * All Rights Reserved.
 *************************************************************************************/
export class Vtiger_WSClient {
	_servicebase = 'webservice.php';
	// TODO: Format the url before appending servicebase
	//url = url + '/';

	_serviceurl: string;

	// Webservice user credentials
	_serviceuser:any = false;
	_servicekey:any = false;
	

	// Webservice login validity
	_servertime:any = false;
	_expiretime:any = false;
	_servicetoken:any = false;

	// Webservice login credentials
	_sessionid:any = false;
	_userid:any = false;
	_ledtipo: any;
	// Last operation error information
	_lasterror:any = false;
	_remember:any = false;
	_contactid:any = false;

	constructor(url:string, jQuery?: JQuery){
		this._serviceurl = url + this._servicebase;
	}

	/**
	 * JSONify input data.
	 */
	toJSON(input?:string, vez = 0) {
		var aux;
		try {
			aux = JSON.parse(input);
			return aux;
		} catch (e) {
			console.log(input);
			if (input)
			if (vez == 0 && input.indexOf('{') != 0) {
				var i = input.indexOf('{');
				input = input.substr(i);
				return this.toJSON(input, 1);
			}
			return input;
		}
	}

	/**
	 * Get actual record id from the response id.
	 */
	getRecordId(id?:string) {
		var ids = id.split('x');
		return ids[1];
	};

	/**
	 * Convert to JSON String.
	 */
	toJSONString(input) {
		return JSON.stringify(input);
	}

	/**
	 * Check if result has any error.
	 */
	hasError = function (resultdata) {
		if (resultdata != null && resultdata['success'] == false) {
			this._lasterror = resultdata['error'];
			return true;
		}
		if (resultdata == null) {
			this._lasterror = true;
			return false;
		}
		this._lasterror = false;
		return false;
	}

	/**
	 * Get last operation error information
	 */
	lastError = function () {
		return this._lasterror;
	}

	/**
	 * Perform the callback now.
	 */
	__performCallback = function (callback, result) {
		if (callback) {
			var callbackFunction = callback;
			var callbackArguments = false;
			if (typeof (callback) == 'object') {
				callbackFunction = callback['function'];
				callbackArguments = callback['arguments'];
			}
			if (typeof (callbackFunction) == 'function') {
				callbackFunction(result, callbackArguments);
			}
		}
	}

	/**
	 * Perform the challenge
	 * @access private
	 */
	__doChallenge = function (username) {
		var reqtype = 'GET';
		var getdata = {
			'operation': 'lpgetchallenge',
			'username': username
		};
		var usethis = this;
		console.log(getdata.operation)
		$.ajax(this._serviceurl,{
			type: reqtype,
			data: getdata,
			// We have to do this in sync manner
			async: false,
			// Pass reference to the client to use it inside callback function.
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				if (usethis.hasError(resobj) == false) {
					var result = resobj['result'];
					usethis._servicetoken = result.token;
					usethis._servertime = result.serverTime;
					usethis._expiretime = result.expireTime;
				}
			}
		});
	}

	/**
	 * Check and perform login if requried.
	 */
	__checkLogin = function () {
		return true;
	}

	/**
	 * Do Login Operation
	 */
	doLogin = function (username, accesskey, callback) {
		this.__doChallenge(username);
		if (this._servicetoken == false) {
			// TODO: Failed to get the service token
			callback(false);
			return false;
		}

		this._serviceuser = username;
		this._servicekey = accesskey;

		var reqtype = 'POST';
		var postdata = {
			'operation': 'lplogin',
			'username': username,
			'secret': encrypt.hex_md5(this._servicetoken + username),
			'pwd': accesskey,

		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: postdata,
			complete: function (res, status) {

				var resobj = usethis.toJSON(res.responseText);
				console.log(resobj)
				if (res.responseJSON['result'] !== undefined && res.responseJSON['result'].hasOwnProperty('time_zone')) {
					let timeZoneValue = res.responseJSON['result'].time_zone;
					let timeZoneParts = timeZoneValue.split('|##|');

					localStorage.setItem('ledtipo',timeZoneParts[0]);
					localStorage.setItem('ledconfidential',timeZoneParts[1]);
					localStorage.setItem('idioma',res.responseJSON['result'].hour_format);
				}else
				localStorage.setItem('ledtipo','');
			
				localStorage.setItem('usuarioLogueado', JSON.stringify(resobj['result']));
				var resflag = false;
				if (usethis.hasError(resobj) == false) {
					var result = resobj['result'];
					usethis._sessionid = result.sessionName;
					usethis._userid = result.userId;
					usethis._contactid = result.customerId;
					usethis._ledtipo = result.time_zone;
					resflag = true;
				}
				usethis.__performCallback(callback, resflag);
			}
		});
	};

	doReLogin = function (callback) {
		this.__doChallenge(this._serviceuser);
		if (this._servicetoken == false) {
			// TODO: Failed to get the service token
			callback(false);
			return false;
		}

		var username = this._serviceuser;
		var accesskey = this._servicekey;

		var reqtype = 'POST';
		var postdata = {
			'operation': 'lplogin',
			'username': username,
			'secret': encrypt.hex_md5(this._servicetoken + username),
			'pwd': accesskey
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: postdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var resflag = false;
				if (usethis.hasError(resobj) == false) {
					var result = resobj['result'];
					usethis._sessionid = result.sessionName;
					usethis._userid = result.userId;
					usethis._contactid = result.customerId;
					resflag = true;
				}
				usethis.__performCallback(callback, resflag);
			}
		});
	};

	/**
	 * Do Query Operation.
	 */
	doQuery = function (query, callback) {
		this.__checkLogin();

		// TODO: Append ; if not found
		if (query.indexOf(';') == -1) query += ';';
		var reqtype = 'GET';
		var getdata = {
			'operation': 'query',
			'sessionName': this._sessionid,
			'query': query
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: getdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var result = false;
				if (usethis.hasError(resobj) == false) {
					result = resobj['result'];
				}
				usethis.__performCallback(callback, result);
			}
		});
	};

	/**
	 * Get Result Column Names.
	 */
	getResultColumns = function (result) {
		var columns = [];
		if (result != null && result.length != 0) {
			var firstrecord = result[0];
			for (var key in firstrecord) {
				columns.push(key);
			}
		}
		return columns;
	};

	/**
	 * List types (modules) available.
	 */
	doListTypes = function (callback) {
		this.__checkLogin();

		var reqtype = 'GET';
		var getdata = {
			'operation': 'listtypes',
			'sessionName': this._sessionid
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: getdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var returnvalue : any = false;
				if (usethis.hasError(resobj) == false) {
					var result = resobj['result'];
					var modulenames = result['types'];

					returnvalue = {};
					for (var mindex = 0; mindex < modulenames.length; ++mindex) {
						var modulename = modulenames[mindex];
						returnvalue[modulename] = {
							'name': modulename
						}
					}
				}
				usethis.__performCallback(callback, returnvalue);
			}
		});
	};

	/**
	 * Do Describe Operation
	 */
	doDescribe = function (module, callback) {
		this.__checkLogin();

		var reqtype = 'GET';
		var getdata = {
			'operation': 'describe',
			'sessionName': this._sessionid,
			'elementType': module
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: getdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var result = false;
				if (!usethis.hasError(resobj)) result = resobj['result'];
				usethis.__performCallback(callback, result);
			}
		});
	};

	/**
	 * Retrieve details of record
	 */
	doRetrieve = function (record, callback) {
		this.__checkLogin();

		var reqtype = 'GET';
		var getdata = {
			'operation': 'retrieve',
			'sessionName': this._sessionid,
			'id': record
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: getdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var result = false;
				if (!usethis.hasError(resobj)) result = resobj['result'];
				usethis.__performCallback(callback, result);
			}
		});
	};

	/**
	 * Do Create Operation
	 */
	doCreate = function (module, valuemap, callback) {
		this.__checkLogin();

		// Assign record to logged in user if not specified
		if (valuemap['assigned_user_id'] == null) {
			valuemap['assigned_user_id'] = this._userid;
		}

		var reqtype = 'POST';
		var postdata = {
			'operation': 'create',
			'sessionName': this._sessionid,
			'elementType': module,
			'element': this.toJSONString(valuemap)
		};
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: postdata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var result = false;
				if (!usethis.hasError(resobj)) result = resobj['result'];
				usethis.__performCallback(callback, result);
			}
		});
	};

	/**
	 * Invoke custom operation
	 */
	doInvoke = function (callback, method, params, type) {
		this.__checkLogin();

		if (typeof (params) == 'undefined') params = {};

		var reqtype = 'POST';
		if (typeof (type) != 'undefined') reqtype = type.toUpperCase();

		var sendata = {
			'operation': method,
			'sessionName': this._sessionid,
		};
		for (var key in params) {
			if (typeof (sendata[key]) == 'undefined') {
				sendata[key] = params[key];
			}
		}
		var usethis = this;
		$.ajax(this._serviceurl, {
			type: reqtype,
			data: sendata,
			complete: function (res, status) {
				var resobj = usethis.toJSON(res.responseText);
				var result = false;
				if (!usethis.hasError(resobj)) result = resobj['result'];
				usethis.__performCallback(callback, result);
			}
		});
	};

};


